<style src="./ModalDetails.scss" lang="scss"></style>
<template>
  <div 
    class="modal inmodal in"
    tabindex="-1"
    :style="display"
    v-if="show"
    v-shortkey="['esc']"
    @shortkey="closeModal"
  >
    <div class="modal-dialog ModalSerproDetails">
      <div class="modal-content animated fadeIn" v-if="!details._id">
        <div class="modal-dialog ModalSerproDetails">
          <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>
        </div>
      </div>

      <div class="modal-content animated fadeIn" v-if="details._id">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">
              Close
            </span>
          </button>
          <h4 class="modal-title">Autuação</h4>
          <h2 class="modal-title licencePlateTitle">{{ details.veiculoPlaca.toUpperCase() }}</h2>
        </div>

        <ModalContent :item="details"/>
      </div>
    </div>
  </div>
</template>

<script>
import ModalContent from '../modal-content/ModalContent.vue';
import Spinner from '../../../../components/Spinner';

export default {
  components: {
    ModalContent,
    Spinner,
  },
  props: {
    show: {
      default: false,
    },
  },
  data() {
    return {
      showSpinner: false,
      details: {},
    };
  },
  computed: {
    display() {
      return this.show ? 'display: block' : 'display: none';
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    async loadDetails(register) {
      try {
        this.showSpinner = true;
        this.details = {};

        const payload = {
          registerId: register._id
        }
        const details = await this.$store.dispatch('SERPRO/GetDetails', payload)
        this.details = details;
      } catch(error) {
        this.$toasted.error(error);
      } finally {
        this.showSpinner = false;
      }
    },
  }
};
</script>
